import { defineComponent as _defineComponent } from 'vue'

export const pinCodeTestId = 'pin-code';
export const imageTestId = 'image';
export const licensePlateTestId = 'license-plate';

import { computed } from 'vue';

// Types
import type { EntryMethod } from '@white-label-types/parking-booking';

// Constants
import { BARRIER_ACCESS_TYPES } from '@white-label-configuration/constants';


interface BTicketAccessInfoParkingProps {
  accessInfo: EntryMethod['entryMethod'] | string;
  accessInfoNumber: number;
  licensePlate: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-access-info-parking',
  props: {
    accessInfo: null,
    accessInfoNumber: null,
    licensePlate: { default: '' }
  },
  setup(__props: any, { expose }) {

const props = __props as { accessInfo: EntryMethod['entryMethod'] | string, accessInfoNumber: number, licensePlate: string };

// Packages


const formattedAccessType = computed(() => {
  return typeof props.accessInfo === 'object'
    ? props.accessInfo.type.toLowerCase()
    : props.accessInfo.toLowerCase();
});

const displayImg = computed(() => {
  return typeof props.accessInfo === 'object'
    && (props.accessInfo.type === BARRIER_ACCESS_TYPES.QRCODE
      || props.accessInfo.type === BARRIER_ACCESS_TYPES.BARCODE);
});

const displayLicensePlate = computed(() => {
  return typeof props.accessInfo === 'object'
    && props.accessInfo.type === BARRIER_ACCESS_TYPES.ANPR;
});

const displayPinCode = computed(() => {
  return typeof props.accessInfo === 'object'
    && props.accessInfo.type === BARRIER_ACCESS_TYPES.PINCODE;
});

expose({
  formattedAccessType,
  displayImg,
  displayLicensePlate,
  displayPinCode,
});

return { __sfc: true,pinCodeTestId, imageTestId, licensePlateTestId, props, formattedAccessType, displayImg, displayLicensePlate, displayPinCode }
}

})